import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const PlayIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M5.425 5.134a.897.897 0 0 1 .873-.04l11.206 5.604a.897.897 0 0 1 0 1.604L6.297 17.905A.896.896 0 0 1 5 17.103V5.897c0-.311.16-.6.425-.763Zm1.368 2.213v8.306L15.1 11.5 6.793 7.347Z", clipRule: "evenodd" }));
});
PlayIcon.displayName = "PlayIcon";
